// extracted by mini-css-extract-plugin
module.exports = {"brandsLeagueList":"brandsLeagueList-IIgpDiLK","listItem":"listItem-2weoxZ0X","brands_content":"brands_content-3IQCkbbE","brands_logo":"brands_logo-2o2wZ7hf"};